import { Translations } from "../i18n";
import "./changelog.css"

export const changelog = (t: Translations) => <>
    <h1>{t.whatsNew}</h1>

    {t.changelogContent}
</>;

const searchParams = new URLSearchParams(window.location.search);
const disableChangelog = searchParams.get("disableChangelog");

const currentVersion = "0.9.1";
export const showChangeLog = localStorage.getItem("lastVersion") !== currentVersion && !disableChangelog;
localStorage.setItem("lastVersion", currentVersion);
